import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_staging/6a1ab12a8be93c0014370eb4_1780309631544/boersenstrompreisdashboard/src/app/components/DashboardShell.tsx");
